<template>
    <div class="content">		
		<div class="page-list-box">
			<div class="page-btns-box">
			    <el-button v-if="$utils.have('/goodsAfterSale/reason/save')" type="primary"  size="small" @click="Add(0)">增加原因</el-button>
			</div>
			<div  style="overflow: auto;">
			    <table ref="table" border="0" class="draggable-table">
			        <thead>
			            <tr>
			                <th>
			                    <div class="cell">排序</div>
			                </th>
							
			                <th>
			                    <div class="cell">原因</div>
			                </th>
			                <th>
			                    <div class="cell">上传照片</div>
			                </th>			               
			                <th>
			                    <div class="cell">操作</div>
			                </th>
			            </tr>
			        </thead>
			        <vuedraggable v-model="dataList"  tag="tbody" handle=".handle"  @change="updateWordSort()">                
			            <template v-if="dataList && dataList.length > 0">
			                <tr v-for="t in dataList" :key="t.id">
			                    <td>
			                        <div class="cell handle">                                
			                            <i class="el-icon-sort"></i>
			                        </div>
			                    </td>
			                   
			                    <td>
			                        <div class="cell">
			                            {{t.reason}}
			                        </div>
			                    </td>
			                    <td>
			                        <div class="cell">
			                            <el-tag size="mini" :type="t.isPhoto == 1 ? 'danger' : 'success'">{{ t.isPhoto == 1 ?  "必须上传" : "选择上传"}}</el-tag>
			                        </div>
			                    </td>			                   
			                    <td>
			                        <div class="cell"> 
			                            <el-button
			                                type="text"
			                                size="small"
			                                icon="el-icon-s-management"
			                                @click="del(t.id)"
			                                v-if="$utils.have('/refundTicketAudit/reason/delete')"
			                                >删除</el-button>
			                        </div>
			                    </td>
			                </tr>
			            </template>
			            <tr v-else class="ignore">
			                <td colspan="9">
			                    <div class="empty">暂无数据</div>
			                </td>
			            </tr>
			        </vuedraggable>
			    </table>
			</div>
		</div>		
		<Add ref="Add" @onUpdate="onUpdateList" ></Add>
    </div>
</template>

<script>
import Add from './components/add';
import vuedraggable from 'vuedraggable';
export default {
    components:{Add,vuedraggable},
    data(){
        return{
           
			listLoading:false,
			dataList: null,
			
        }
    },
    computed:{
        
    },
    mounted() {
        this.getDataList()
    },
    methods:{
       //获取列表
       getDataList() {           
           this.listLoading = true;
           this.$request({
               url: "/refundTicketAudit/reason/list",
               method: "POST",
               data: {
					          
               },
           })
               .then((res) => {
                   const { state, msg, result } = res.data;
                   if (state == 1 && result) {
					    this.dataList = result || [];
						this.listLoading = true
                   } else {
                       this.$message.error(msg || "请求失败");
                   }
               })
               .catch(() => {
                   this.$message.error("请求错误");
               })
               .finally(() => {
                  this.listLoading = false;
               });
       },
       
	   async onUpdateList(){
	       this.getDataList();  
	   },
       del(id){		   
		  this.$confirm('删除该原因后，用户将无法选择该售后原因。确认删除？', '提示', {
		      confirmButtonText: '确认删除',
		      cancelButtonText: '取消',
		      type: 'warning',
		      center: true,
		      closeOnClickModal: false
		  }).then(()=> {
		      this.$request({
		          url: "/refundTicketAudit/reason/delete",
		          method: "POST",
		          params:{
		              id:id
		          }
		      }).then(res=> {
		          const { state, msg } = res.data;
		          if (state && state == 1 ) {
		              this.$message.success("删除成功");
					  this.getDataList()
		              
		          } else {
		              return this.$message.error(msg || "删除失败");
		          }
		      })
		  }).catch(()=> {})  
	   },
	   Add(){
	       this.$refs.Add.show();
	   },
	   updateWordSort(){
		   var data = {}
		   data = this.dataList.map((i, idx)=>{
		       i.sort = idx + 1;          
		       return {
		           sort: i.sort,
		           id: i.id
		       }
		   })     
	       this.$request({
	           url: "/refundTicketAudit/reason/sort",
	           method: "POST",
	           data
	       }).then((res) => {
	               const { state, msg } = res.data;
	               if (state == 1 ) {
	                   this.$message.success("操作成功");
					    this.getDataList();   
	               } else {
	                   this.$message.error(msg || "请求失败");
	               }
	           })
	           .catch(() => {
	               this.$message.error("请求错误");
	           })
	   },
       
    }
}
</script>
<style lang="scss" scoped>
.draggable-table {
    table-layout: auto;
    border-collapse: collapse;
    width: 100%;
    min-width: 710px;
    border: 1px solid #ebeef5;

    .empty {
        text-align: center;
        line-height: 20px;
        color: #909399;
    }

    th,
    td {
        position: relative;
        padding: 10px 0;
        text-align: left;
        border: 1px solid #ebeef5;
        border-top: 0;
        border-left: 0;
        vertical-align: middle;
        box-sizing: border-box;

        .cell {
            padding: 0 10px;
            width: 100%;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            overflow: hidden;
            box-sizing: border-box;

            &.handle {
                cursor: move;
            }
        }
    }

    th {
        background-color: #f5f7fa;
        font-size: 13px;
        color: #909399;
        font-weight: 700;
        .cell{
            white-space: nowrap;
        }
    }

    td {
        font-size: 13px;
        color: #606266;
    }

    tr:hover td {
        background-color: #f5f7fa;
    }
}
</style>sss